import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Spin, Avatar, Card, Typography, Tag } from 'antd';
import moment from 'moment';
import { useDocument } from 'react-firebase-hooks/firestore';
import Client from 'containers/app/client';
import BookingUtils from 'utils/bookings';
import { sectors, orgTypes } from 'utils/roles-sectors';
import { getLabel } from 'utils/labels';
import './style.css';

const { getColorByStatus } = BookingUtils;

const BookingCard = ({
  profile,
  request,
  user,
  actions,
  children,
  organisation,
}) => {
  const { dateStart, status, notes } = request;
  const ref = Client.db.doc(`users/${user}`);
  const [doc, loading, error] = useDocument(ref);

  if (loading) return <Spin />;
  if (error) throw error;
  if (!doc.data()) return null;

  const { info } = doc.data();
  const expired = moment(dateStart).isBefore(moment());
  const fStatus = expired ? 'expired' : status;
  const name =
    organisation && organisation.info
      ? organisation.info.name
      : `${info.firstName} ${info.lastName}`;

  return (
    <Card className="booking-request-card" actions={actions}>
      <Card.Meta
        avatar={
          <Link to={profile}>
            <Avatar size={80} src={info.photoURL} />
          </Link>
        }
        title={<Link to={profile}>{name}</Link>}
        description={
          <>
            {organisation && organisation.type && (
              <Typography>
                {getLabel(organisation.type.service, sectors)}
              </Typography>
            )}
            {organisation && organisation.type && (
              <Typography>
                {getLabel(organisation.type.type, orgTypes)}
              </Typography>
            )}
            <Tag color={getColorByStatus(fStatus)}>{fStatus}</Tag>
            {notes && <Typography>{notes}</Typography>}
          </>
        }
      />
      {children}
    </Card>
  );
};

BookingCard.propTypes = {
  profile: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  user: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(PropTypes.node).isRequired,
  request: PropTypes.shape({
    dateStart: PropTypes.string,
    dateEnd: PropTypes.string,
    rate: PropTypes.number,
    worker: PropTypes.string,
    status: PropTypes.string,
    notes: PropTypes.string,
  }).isRequired,
  organisation: PropTypes.shape({
    info: PropTypes.shape({
      name: PropTypes.string,
    }),
    type: PropTypes.shape({
      type: PropTypes.string,
      service: PropTypes.string,
    }),
  }),
};

BookingCard.defaultProps = {
  organisation: null,
};

export default BookingCard;
